import { hashKey, useQuery } from '@tanstack/react-query';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface FetchGroupsProps {
  filters: any;
}

interface DeclarationGroupsMeta {
  total: number;
}

export const useDeclarationGroupsMeta = ({ filters }: FetchGroupsProps) =>
  useQuery({
    queryKey: ['declaration-groups-meta', hashKey(filters)],
    queryFn: async (): Promise<DeclarationGroupsMeta> => {
      try {
        const actualFilters = { ...filters };

        const { metadata } = await request({
          path: `declarations/retrieve-declaration-groups-metadata`,
          method: 'POST',
          authenticate: true,
          dataObject: { criteria: { filters: actualFilters } },
        });
        return { total: metadata?.total };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration groups metadata');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
